/** admin/launch — HOOKS. */
import { useMutation, useQuery } from '@tanstack/react-query';
import { adminLaunchApi } from './api';
import { adminLaunchKeys } from './keys';
import type { LaunchMatchPayload } from './types';

export function useTestPersonas(enabled = true) {
  return useQuery({
    queryKey: adminLaunchKeys.testPersonas(),
    queryFn: () => adminLaunchApi.fetchTestPersonas(),
    enabled,
  });
}

export function useLaunchMatch() {
  return useMutation({ mutationFn: (payload: LaunchMatchPayload) => adminLaunchApi.launchMatch(payload) });
}
